"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessingType = exports.VerificationType = void 0;
/** Type of verification to be used to authenticate user */
var VerificationType;
(function (VerificationType) {
    VerificationType["Password"] = "PASSWORD";
    VerificationType["TouchId"] = "TOUCHID";
    VerificationType["Fido2"] = "FIDO2";
    VerificationType["SecurityQuestion"] = "SECURITY_QUESTION";
    VerificationType["Sms"] = "SMS";
    VerificationType["Ivr"] = "IVR";
    VerificationType["Face"] = "FACE";
    VerificationType["Totp"] = "TOTP";
    VerificationType["Email"] = "EMAIL";
    VerificationType["BackupCode"] = "BACKUPCODE";
    VerificationType["Pattern"] = "PATTERN";
    VerificationType["Push"] = "PUSH";
    VerificationType["Voice"] = "VOICE";
})(VerificationType || (exports.VerificationType = VerificationType = {}));
/** defines whether the the process will be done via email link or whether the user needs to enter a code to complete the process. */
var ProcessingType;
(function (ProcessingType) {
    ProcessingType["Code"] = "CODE";
    ProcessingType["Link"] = "LINK";
})(ProcessingType || (exports.ProcessingType = ProcessingType = {}));
